import { render, staticRenderFns } from "./DefaultItem.vue?vue&type=template&id=4a3ab050&scoped=true&"
import script from "./DefaultItem.vue?vue&type=script&lang=js&"
export * from "./DefaultItem.vue?vue&type=script&lang=js&"
import style0 from "./DefaultItem.vue?vue&type=style&index=0&id=4a3ab050&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3ab050",
  null
  
)

export default component.exports